"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VanillaOidc = void 0;
const oidc_js_1 = require("./oidc.js");
const parseTokens_js_1 = require("./parseTokens.js");
class VanillaOidc {
    constructor(oidc) {
        this._oidc = oidc;
    }
    subscribeEvents(func) {
        return this._oidc.subscribeEvents(func);
    }
    removeEventSubscription(id) {
        this._oidc.removeEventSubscription(id);
    }
    publishEvent(eventName, data) {
        this._oidc.publishEvent(eventName, data);
    }
    static get(name = 'default') {
        return new VanillaOidc(oidc_js_1.Oidc.get(name));
    }
    tryKeepExistingSessionAsync() {
        return this._oidc.tryKeepExistingSessionAsync();
    }
    loginAsync(callbackPath = undefined, extras = null, isSilentSignin = false, scope = undefined, silentLoginOnly = false) {
        return this._oidc.loginAsync(callbackPath, extras, isSilentSignin, scope, silentLoginOnly);
    }
    logoutAsync(callbackPathOrUrl = undefined, extras = null) {
        return this._oidc.logoutAsync(callbackPathOrUrl, extras);
    }
    silentLoginCallbackAsync() {
        return this._oidc.silentLoginCallbackAsync();
    }
    renewTokensAsync(extras = null) {
        return this._oidc.renewTokensAsync(extras);
    }
    loginCallbackAsync() {
        return this._oidc.loginCallbackWithAutoTokensRenewAsync();
    }
    get tokens() {
        return this._oidc.tokens;
    }
    get configuration() {
        return this._oidc.configuration;
    }
    getValidTokenAsync(waitMs = 200, numberWait = 50) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, parseTokens_js_1.getValidTokenAsync)(this._oidc, waitMs, numberWait);
        });
    }
    userInfoAsync(noCache = false) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._oidc.userInfoAsync(noCache);
        });
    }
}
exports.VanillaOidc = VanillaOidc;
VanillaOidc.getOrCreate = (getFetch) => (configuration, name = 'default') => {
    return new VanillaOidc(oidc_js_1.Oidc.getOrCreate(getFetch)(configuration, name));
};
VanillaOidc.eventNames = oidc_js_1.Oidc.eventNames;
//# sourceMappingURL=vanillaOidc.js.map